app = angular.module('harriApp');

/**
 * JOB Application API
 * ---
 * Contain set of API's for job application.
 */
app.factory('jobApplyAPI',  ["httpHelper", "$timeout", "$q", "asyncGlobalHandler", "hUser", function (httpHelper, $timeout, $q, asyncGlobalHandler, hUser) {

    var jobApplyAPI = {};

    /**
     * getJobDetails
     *
     * return job details for that job.
     *
     * @param job_id
     * @returns {*}
     */
    jobApplyAPI.getJobDetails = function (job_id) {
        var result;
        if (job_id) {
            result = httpHelper.g('job_apply/job_application_details/' + job_id);
            asyncGlobalHandler.watchPromise(result);
            return result;
        }
        else {
            return false;
        }
    } ;


    /**
     * checkApply
     *
     * @param id
     * @returns {*}
     */
    var x = false
    jobApplyAPI.checkApply = function (job_id) {
        var result;
        if (job_id) {
            result = httpHelper.g('job_apply/check_apply/' + job_id);
            asyncGlobalHandler.watchPromise(result);
            return result;
        }
        else {
            return false;
        }
    };


    /**
     * getApplicationStatus
     *
     * @param job_id
     * @returns  promise resolve the following values :
     *
     *  - NOT_LOGGED_IN : user is not logged in so he didn't apply for that job.
     *  - LOGGED_IN_BUT_NOT_APPLIED: user is logged in but didn't apply for that job.
     *  - DRAFT draft
     *  - 'Something 5ara happen' rejected
     *
     *  login applied
     *  ---
     *  login & work history
     *  login without work history
     *  --
     *
     */
    jobApplyAPI.getApplicationStatus = function (job_id, getOnly) {
        var result, deferred = $q.defer();
        if (job_id) {
            jobApplyAPI.checkApply(job_id).then(function (checkApplyResponse) {

                var status_combination = checkApplyResponse.data.data;

                if (!status_combination) {
                    deferred.reject('Something 5ara happen with the response ');
                }

                else if (status_combination.is_login === false) {
                    deferred.resolve({ type: 'NOT_LOGGED_IN', 'data': status_combination});
                    hUser.logout();
                }

                else if (status_combination.is_applied === true && status_combination.is_draft == true) {
                    deferred.resolve({ type: 'DRAFT', 'data': status_combination});
                }

                else if (status_combination.is_applied === true && status_combination.is_draft == false) {
                    deferred.resolve({ type: 'APPLIED', 'data': status_combination});
                }

                else if (status_combination.is_login == true && !status_combination.hasOwnProperty('application_id')) {
                    if(getOnly){
                        deferred.resolve({ type: 'LOGGED_IN_BUT_NOT_APPLIED',  'data': status_combination });
                    }else {
                        jobApplyAPI.createDraft(job_id).then(function (draft_data) {
                            status_combination.application_id = draft_data.data.data.application_id;
                            deferred.resolve({type: 'DRAFT', 'data': status_combination});
                        });
                    }
                }

                else if (status_combination.hasOwnProperty('application_id') && status_combination.is_draft == true) {
                    deferred.resolve({ type: 'DRAFT', application_id: status_combination.application_id,  'data': status_combination });
                }

                // else ??

            }, function (err) {
                deferred.reject('Something 5ara happen with the response ', err);
            });
        }
        else {
            return false;
        }

        return deferred.promise;
    };


    /**
     * createDraft
     *
     * @param app_id
     */
    //we queue multiple promises for create draft to solve the duplicate request issue
    //HARRI-8429
    var createDraftPromises = [];
    var createDraftTimeout = null;
    jobApplyAPI.createDraft = function (job_id, jobApplyType) {
        var deferred = $q.defer();

        if (job_id) {
            var trackingSourceData = ReferralUtils.getRefererSource();
            var creareDraftURL = 'job_apply/create_draft/' + job_id;

            //adding source tracking to create draft URL
            if (trackingSourceData.referrer_campaign) {
                creareDraftURL = join_query_link(creareDraftURL, {'referrer_campaign': encodeURIComponent(trackingSourceData.referrer_campaign)});
            }

            trackingSourceData.referrer = trackingSourceData.referrer || 'private';

            if (trackingSourceData.referrer) {
                creareDraftURL = join_query_link(creareDraftURL, {'referrer': encodeURIComponent(trackingSourceData.referrer)});
            }

            if (trackingSourceData.device_type) {
                creareDraftURL = join_query_link(creareDraftURL, {'device_type': encodeURIComponent(trackingSourceData.device_type)});
            }

            if (jobApplyType) {
                creareDraftURL = join_query_link(creareDraftURL, {'type': encodeURIComponent(jobApplyType)});
            }

            createDraftPromises.push(deferred);
            clearTimeout(createDraftTimeout);
            createDraftTimeout = setTimeout(function () {
                let createDraftURL = `${publicConfiguration.APIServerBaseURL.replace("v1", "v2")}${creareDraftURL}`;
                httpHelper.g(createDraftURL)
                    .then(function(result) {
                        for(var i in createDraftPromises) {
                            createDraftPromises[i].resolve(result);
                        }
                        createDraftPromises = [];
                    });
            }, 500);

            return deferred.promise;
        }
        else {
            console.error("No job_id provided:", job_id);
            deferred.reject("No");
        }

        return deferred.promise;
    };

    /**
     * addNewVideoAnswer
     *
     * @param application_id
     * @param recorded_url
     *
     * @returns {*}
     */
    jobApplyAPI.addNewVideoAnswer = function (application_id, recorded_url) {
        return httpHelper.put('job_apply/application_recorded_video', {
            application_id: application_id,
            recorded_url: recorded_url
        });
    };

    /**
     * Delete Application Media
     *
     * @param media_id
     * @returns {*}
     */
    jobApplyAPI.deleteApplicationMedia = function (media_id) {
        if (media_id) {
            var result = httpHelper.d('job_apply/delete_application_media/' + media_id);
            asyncGlobalHandler.watchPromise(result);
            return result;
        }
        else {
            return false;
        }
    };

    /**
     * apply job
     *
     * @param params
     * @returns {*}
     */
    jobApplyAPI.applyJob = function (params) {
        if (params) {

            params = $.extend( params, ReferralUtils.getRefererSource());
            let url =  `${publicConfiguration.APIServerBaseURL.replace("v1", "v2")}job_apply/apply`;
            var result = httpHelper.p(url, params);
            asyncGlobalHandler.watchPromise(result);
            return result;
        }
        else{
            return false;
        }
    };



    jobApplyAPI.loadDraft = function (app_id) {
        if (app_id) {
            var result = httpHelper.g('job_apply/load_draft/'+app_id);
            asyncGlobalHandler.watchPromise(result);
            return result;
        }
        else{
            return false;
        }
    };

    /**
     * get application media presigned Url
     *
     * @param params
     * @returns {*}
     */
    jobApplyAPI.getAppMediaPresignedUrl = function (app_id, application_document_id, file_name, placeholderToken) {
        if (app_id && application_document_id && file_name) {
            let url = `applications/${app_id}/application_media/presigned_url?type=application_document&application_document_id=${application_document_id}&file_name=${file_name}`;

            if (placeholderToken) {
                url += `&placeholder_token=${placeholderToken}`;
            }
            const result = httpHelper.g(url);
            asyncGlobalHandler.watchPromise(result);
            return result;
        } else {
            return false;
        }
    };

    /**
     * upload application media
     *
     * @param params
     * @returns {*}
     */
    jobApplyAPI.uploadAppMedia = function (app_id, payload) {
        if (app_id && payload) {
            var result = httpHelper.p('applications/' + app_id + '/application_media',payload);
            asyncGlobalHandler.watchPromise(result);
            return result;
        } else {
            return false;
        }
    };


    /**
     * Get Recommended Jobs after user successfully applied for a job
     */
    jobApplyAPI.getRecommendedJobs = function( searchObj ){
        /**
         * search request obj
         */
        var searchRequest = {
          search_phrase : '',
          start: 0,
          size: 4,
          ignore_my_jobs : 1,
          radius: 30,
          positions : [],
          hecs : [],
          location : []
        };

        searchRequest.positions = searchObj.positions;
        searchRequest.hecs = searchObj.hecs;
        if( searchObj.location && searchObj.location.length ){
          searchRequest.location = [ searchObj.location[0] ,  searchObj.location[1] ];
        }

        var requestPromise = httpHelper.p('harri_search/search_jobs', searchRequest );
        asyncGlobalHandler.watchPromise( requestPromise );
        return requestPromise;
    }

    return jobApplyAPI;

}]);
